'use client'

import { ErrorFallback } from '@/components/errors/error-fallback'

export default function MarketingError({
  error,
  unstable_retry,
  reset,
}: {
  error: Error & { digest?: string }
  unstable_retry?: () => void
  reset?: () => void
}) {
  return (
    <ErrorFallback
      error={error}
      unstable_retry={unstable_retry}
      reset={reset}
      area="marketing"
      route="/(marketing)"
      publicPage
    />
  )
}
